module.exports = __webpack_public_path__ + "static/media/turn-around.bfaa8aab.svg";